import { SHA256 } from 'crypto-js';

import { arrayBufferToBase64, base64ToArrayBuffer } from '@/Utils/cryptoUtils';

interface ISignProps {
    uuid?: string;
    userId?: string;
}
const hashToCombinedStringMap = new Map<string, string>();

export const getCombinedStringFromHash = (hash: string) => {
    return hashToCombinedStringMap.get(hash);
};

export const generateUserSign = async ({
    uuid = '',
    userId = '',
}: ISignProps) => {
    const combinedString = uuid + userId;
    const hash = SHA256(combinedString).toString();
    return { sign: hash };
};

export function chunkMessage(message, chunkSize) {
    const chunks = [];
    for (let i = 0; i < message.length; i += chunkSize) {
        chunks.push(message.slice(i, i + chunkSize));
    }
    return chunks;
}

// Function to concatenate chunks into a single message
export function concatenateChunks(chunks) {
    return chunks.join('');
}

export async function encryptWithPublicKey(
    message: string,
    publicKeyStringified: string,
) {
    const publicKey = JSON.parse(publicKeyStringified);
    const encoder = new TextEncoder();
    const data = encoder.encode(message);

    const importedPublicKey = await window.crypto.subtle.importKey(
        'jwk',
        publicKey,
        { name: 'RSA-OAEP', hash: { name: 'SHA-256' } },
        true,
        ['encrypt'],
    );

    const encryptedData = await window.crypto.subtle.encrypt(
        { name: 'RSA-OAEP' },
        importedPublicKey,
        data,
    );

    return arrayBufferToBase64(encryptedData);
}

export async function decryptWithPrivateKey(
    encryptedData,
    privateKeyStringified,
) {
    const encryptedArrayBuffer = base64ToArrayBuffer(encryptedData);
    const privateKey = JSON.parse(privateKeyStringified);

    const importedPrivateKey = await window.crypto.subtle.importKey(
        'jwk',
        privateKey,
        { name: 'RSA-OAEP', hash: { name: 'SHA-256' } },
        true,
        ['decrypt'],
    );

    const decryptedData = await window.crypto.subtle.decrypt(
        { name: 'RSA-OAEP' },
        importedPrivateKey,
        encryptedArrayBuffer,
    );

    const decoder = new TextDecoder();
    return decoder.decode(decryptedData);
}
